// Each subMenu group: { title: string, items: LinkItem[] }
// Legacy format (array only) is still supported as fallback.

export function getSubMenuGroup(group, fallbackTitle = "") {
  if (Array.isArray(group)) {
    return { title: fallbackTitle, items: group };
  }

  return {
    title: group?.title || fallbackTitle,
    items: group?.items || [],
  };
}

export function getSubMenuGroups(subMenu = {}) {
  return Object.entries(subMenu).map(([key, group]) => ({
    key,
    ...getSubMenuGroup(group, key),
  }));
}
